document.addEventListener("DOMContentLoaded", function () {
  function hideElement(element) {
    if (element) {
      element.style.display = "none";
    }
  }

  function showElement(element) {
    if (element) {
      element.style.display = "block";
    }
  }

  function fadeIn(element, duration = 300) {
    if (!element) return;

    element.style.opacity = 0;
    element.style.display = "block";

    let start = null;

    function animate(timestamp) {
      if (!start) start = timestamp;

      const progress = timestamp - start;
      const opacity = Math.min(progress / duration, 1);

      element.style.opacity = opacity;

      if (progress < duration) {
        requestAnimationFrame(animate);
      }
    }

    requestAnimationFrame(animate);
  }

  function getInputByName(name) {
    return Array.from(document.querySelectorAll("input")).find(function (input) {
      return input.getAttribute("name") === name;
    });
  }

  // Hide all tab content
  document.querySelectorAll(".tab_content").forEach(function (content) {
    hideElement(content);
  });

  // Show first tab content
  const firstTabContent = document.querySelector(".tab_content");
  showElement(firstTabContent);

  // Tab click
  document.querySelectorAll("ul.tabs li").forEach(function (tab) {
    tab.addEventListener("click", function () {
      document.querySelectorAll(".tab_content").forEach(function (content) {
        hideElement(content);
      });

      const activeTab = this.getAttribute("rel");
      const activeContent = document.getElementById(activeTab);

      fadeIn(activeContent);

      document.querySelectorAll("ul.tabs li").forEach(function (item) {
        item.classList.remove("active");
      });

      this.classList.add("active");

      document.querySelectorAll(".tab_drawer_heading").forEach(function (heading) {
        heading.classList.remove("d_active");
      });

      document
        .querySelectorAll(".tab_drawer_heading[rel^='" + activeTab + "']")
        .forEach(function (heading) {
          heading.classList.add("d_active");
        });
    });
  });

  // Mobile drawer tab heading click
  document.querySelectorAll(".tab_drawer_heading").forEach(function (heading) {
    heading.addEventListener("click", function () {
      document.querySelectorAll(".tab_content").forEach(function (content) {
        hideElement(content);
      });

      const activeTab = this.getAttribute("rel");
      const activeContent = document.getElementById(activeTab);

      fadeIn(activeContent);

      document.querySelectorAll(".tab_drawer_heading").forEach(function (item) {
        item.classList.remove("d_active");
      });

      this.classList.add("d_active");

      document.querySelectorAll("ul.tabs li").forEach(function (tab) {
        tab.classList.remove("active");
      });

      document
        .querySelectorAll("ul.tabs li[rel^='" + activeTab + "']")
        .forEach(function (tab) {
          tab.classList.add("active");
        });
    });
  });

  // Add class to last tab
  const allTabs = document.querySelectorAll("ul.tabs li");
  if (allTabs.length > 0) {
    allTabs[allTabs.length - 1].classList.add("tab_last");
  }

  // Quantity plus
  document.querySelectorAll(".qtyplus").forEach(function (button) {
    button.addEventListener("click", function (e) {
      e.preventDefault();

      const fieldName = this.getAttribute("field");
      const input = getInputByName(fieldName);

      if (!input) return;

      const currentVal = parseInt(input.value, 10);

      if (isNaN(currentVal)) {
        input.value = 1;
      } else {
        input.value = currentVal + 1;
      }

      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  });

  // Quantity minus
  document.querySelectorAll(".qtyminus").forEach(function (button) {
    button.addEventListener("click", function (e) {
      e.preventDefault();

      const fieldName = this.getAttribute("field");
      const input = getInputByName(fieldName);

      if (!input) return;

      const currentVal = parseInt(input.value, 10);

      if (!isNaN(currentVal) && currentVal > 1) {
        input.value = currentVal - 1;
      } else {
        input.value = 1;
      }

      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  });
});